import T from './translate';

export const getPlaceholderWithText = (text: string) => {
	return `${T('default.enter')} ${text.toLowerCase()}`;
};

const getPlaceholder = function (datatype: string) {
	const isSelectType = ['Select', 'User', 'Users'].includes(datatype);
	const isNumberType = ['Percent', 'Discount', 'Integer'].includes(datatype);
	const placeholderType = isSelectType ? 'Select' : isNumberType ? 'Number' : datatype;
	return isSelectType ? T('default.select') : getPlaceholderWithText(T(`admin.customfieldType.${placeholderType}`));
};

export default getPlaceholder;
